import { MainLayout } from 'shared/ui/layout/main';

import { MobileAppTabs } from '../tabs';

export function MobileAppLayout() {
  return <MainLayout tabs={<MobileAppTabs />} />;
}
